<template>
  <div class="conversion-wrapper">
    <app-filter :filter-list="table_filter" @search="search" />
    <div class="text-right mb-20">
      <el-button type="success" :loading="pull_loading" size="mini" @click="() => onPull()">{{ pull_loading ? '同步中...' : '同步' }}</el-button>
    </div>
    <app-table
      ref="channel_package_ref"
      :table-key="table_key"
      :tablep="tableParams"
      :get-data="getList"
    />
  </div>
</template>

<script>
import { isFunction } from '@/utils/is';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    // 表格查询参数
    tableParams: {
      type: Object,
      required: true,
    },
    // 表格请求方法
    getList: {
      type: Function,
      required: true,
    },
    // 同步请求参数
    pullParams: {
      type: Object,
      required: true,
    },
    // 同步请求方法
    pullApi: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      pull_loading: false,
      table_filter: require('./model/table-filter.js')(this),
      table_key: require('./model/table-key.js')(this),
    };
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 过滤参数
     */
    search(params) {
      Object.assign(this.tableParams.filtering, { ...params.filtering });
      this.seekTable();
    },
    /**
     * 确定选择
     * @param {Object} data 数据
     */
    onDataDialogConfirm(data) {
      this.$emit('confirm', data);
    },
    /**
     * 同步应用渠道包
     * @returns {Promise<void>}
     */
    async onPull() {
      try {
        this.pull_loading = true;
        const { message = '同步成功' } = await this.pullApi(this.pullParams);
        this.$message.success(message);
        this.seekTable();
      } finally {
        this.pull_loading = false;
      }
    },
    /**
     * 刷新表格
     * @returns {void}
     */
    seekTable() {
      const channel_package_ref = this.$refs.channel_package_ref;
      if (!channel_package_ref || !isFunction(channel_package_ref.seekTable)) {
        return;
      }
      channel_package_ref.seekTable();
    },
  },
};
</script>
